import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import MobileWalletAppHero from "./MobileWalletAppHero";
import LetHelpYou from "./LetHelpYou";
import NonCustodialSecurity from "./NonCustodialSecurity";
import GetYourCrypto from "./GetYourCrypto";
import WhyChoose from "../NFT Wallet/WhyChoose";

function MobileWalletApp() {
  return (
    <div>
      <Header />
      <MobileWalletAppHero />
      <LetHelpYou />
      <NonCustodialSecurity />
      <GetYourCrypto />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default MobileWalletApp;
